// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"751":"91ca66a6","897":"57bdec22"}[chunkId] + ".chunk.js";
};